export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_lemon.13f6b41b.jpg";